import React from 'react';
import Portal from '../UI/Portal';
import modalStyles from './Modal.module.css';
import { ReactComponent as CrossIcon } from './icons/crossIcon.svg';

const WorkModal = ({ isOpen, onClose, children }) => {
    if (!isOpen) {
        return null;
    }

    return (
        <Portal>
            <div className={modalStyles.modalOverlay} onClick={onClose}>
                <div
                    className={modalStyles.modalContentWrapper}
                    onClick={(e) => e.stopPropagation()}
                >
                    <button
                        className={modalStyles.modalClose}
                        onClick={onClose}
                    >
                        <CrossIcon />
                    </button>
                    {children}
                </div>
            </div>
        </Portal>
    );
};

export default WorkModal;
